import React, { useState } from 'react';
import Modal from './Modal';
import WhatsappIcon from '../../images/inline/what.inline.svg';
import ChatPerson1 from '../../images/chat-person-1.png';
import ChatPerson2 from '../../images/chat-person.png';
import BaseText from '../ui/typography/BaseText';
import WhatsappQrCode from '../../images/whatsapp-qr-code.png';
import { LINKS } from '../../constants/enum';
export default function WhatsappModal({ iconOnly, fill }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div>
      {!iconOnly ? (
        <div
          onClick={handleOpenModal}
          className="md:w-3/5 w-4/5 mt-6 mx-auto chat-button flex items-center justify-between border border-blue-500 rounded-lg text-blue-500 py-2 px-3 cursor-pointer hover:bg-blue-500 hover:text-white"
        >
          <div className="flex">
            <img
              src={ChatPerson1}
              className="w-10 h-10 rounded-full border border-white"
              alt="chat-person"
              height={40}
              width={40}
            />
            <img
              className="-ml-2 w-10 h-10 rounded-full border border-white"
              src={ChatPerson2}
              alt="chat-person"
              height={40}
              width={40}
            />
          </div>{' '}
          Chat with us <WhatsappIcon />
        </div>
      ) : (
        <div onClick={handleOpenModal} className="cursor-pointer">
          <WhatsappIcon fill={fill} />
        </div>
      )}

      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <BaseText title="Chat with us on WhatsApp" />
        <BaseText textColor="text-gray-200" title="Scan the QR code or click the link below" />
        <img className="mx-auto my-4" src={WhatsappQrCode} alt="whatsapp-qr-code" height={256} width={256} />
        <a
          target="_blank"
          rel="noreferrer"
          href={`${LINKS?.whatsapp}`}
          className="text-lg text-orange-500 hover:underline"
        >
          or access WhatsApp on your desktop
        </a>
      </Modal>
    </div>
  );
}

WhatsappModal.defaultProps = {
  iconOnly: true
};
